import { render, staticRenderFns } from "./AudioPodcastElement.vue?vue&type=template&id=665eeefc&scoped=true&"
import script from "./AudioPodcastElement.vue?vue&type=script&lang=ts&"
export * from "./AudioPodcastElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665eeefc",
  null
  
)

export default component.exports